import axios from './axios'
import axiosLib, { AxiosRequestConfig } from 'axios'

export type GetResponse = {
	url?: string
	[k: string]: any | undefined
}

export default async function getImageService(config: AxiosRequestConfig) {
  const source = axiosLib.CancelToken.source()
  return axios({
    ...config,
    cancelToken: source.token,
  })
    .then(response => {
      return response
    })
    .finally(() => {
      source.cancel()
    })
}
